import { FC } from 'react';
import DeleteIcon from '@/assets/disable.svg';
import { Button } from '@/components/ui/button';
import { api } from '@/redux/api';

export type UnassignAddressBookButtonProps = {
  organisationId: number;
  unitId: number;
  addressBookId: string;
};

/**
 * Removes (unassigns) an address book from the unit. Unit-scoped: this detaches
 * the book from the whole unit, not a single device.
 */
export const UnassignAddressBookButton: FC<UnassignAddressBookButtonProps> = ({
  organisationId,
  unitId,
  addressBookId,
}) => {
  const [unassignAddressBook] = api.useUnassignAddressBookMutation();

  return (
    <Button
      className="place-self-start"
      onClick={() => {
        unassignAddressBook({
          organisationId,
          unitId,
          addressBookId,
          actionType: 'unassignAddressBook',
        });
      }}
      variant="primary-warning"
    >
      Remove address book
      <DeleteIcon className="h-6" />
    </Button>
  );
};
